var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
// SPDX-FileCopyrightText: 2023 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useState } from "react";
import { DatagridConfigurable, List, TextField, FunctionField, NumberField, useRecordContext, TextInput, DateTimeInput, } from "react-admin";
import { ListActions } from "@/components/ListActions";
import { useTranslation } from "react-i18next";
import { Dialog } from "@sequentech/ui-essentials";
import { EXPORT_ELECTION_EVENT_LOGS } from "@/queries/ExportElectionEventLogs";
import { useMutation } from "@apollo/client";
import { IPermissions } from "@/types/keycloak";
import { ResetFilters } from "./ResetFilters";
import { MenuItem, Menu } from "@mui/material";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
import { useLogsPermissions } from "@/resources/ElectionEvent/useLogsPermissions";
import { MessageField } from "./MessageField";
var ExportFormat;
(function (ExportFormat) {
    ExportFormat["CSV"] = "CSV";
    // turns out that the pdf is zipped
    ExportFormat["PDF"] = "PDF";
})(ExportFormat || (ExportFormat = {}));
var OMIT_FIELDS = ["user_id"];
var ExportDialog = function (_a) {
    var electionEventId = _a.electionEventId, openExport = _a.openExport, setOpenExport = _a.setOpenExport, exportFormat = _a.exportFormat;
    var t = useTranslation().t;
    var exportElectionEventActivityLogs = useMutation(EXPORT_ELECTION_EVENT_LOGS, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.LOGS_EXPORT,
            },
        },
    })[0];
    var _b = useWidgetStore(), addWidget = _b[0], setWidgetTaskId = _b[1], updateWidgetFail = _b[2];
    var download = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, exportElectionEventData, errors, task_id, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    currWidget = addWidget(ETasksExecution.EXPORT_ACTIVITY_LOGS_REPORT, undefined);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, exportElectionEventActivityLogs({
                            variables: {
                                electionEventId: electionEventId,
                                format: exportFormat,
                            },
                        })];
                case 2:
                    _a = _c.sent(), exportElectionEventData = _a.data, errors = _a.errors;
                    if (errors) {
                        updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/];
                    }
                    task_id = (_b = exportElectionEventData === null || exportElectionEventData === void 0 ? void 0 : exportElectionEventData.export_election_event_logs) === null || _b === void 0 ? void 0 : _b.task_execution.id;
                    setWidgetTaskId(currWidget.identifier, task_id);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var confirmExportAction = function () {
        setOpenExport(false);
        download();
    };
    return (_jsx(Dialog, __assign({ variant: "info", open: openExport, ok: t("common.label.export"), cancel: t("common.label.cancel"), title: t("common.label.exportFormat", {
            item: t("logsScreen.title"),
            format: exportFormat,
        }), handleClose: function (result) {
            if (result) {
                confirmExportAction();
            }
            else {
                setOpenExport(false);
            }
        } }, { children: _jsx("span", { children: t("logsScreen.exportdialog.description") }) })));
};
export var ElectoralLogFilters;
(function (ElectoralLogFilters) {
    ElectoralLogFilters["ID"] = "id";
    ElectoralLogFilters["STATEMENT_KIND"] = "statement_kind";
    ElectoralLogFilters["USER_ID"] = "user_id";
    ElectoralLogFilters["USERNAME"] = "username";
})(ElectoralLogFilters || (ElectoralLogFilters = {}));
export var ElectoralLogList = function (_a) {
    var _b;
    var aside = _a.aside, filterToShow = _a.filterToShow, filterValue = _a.filterValue, electionEventId = _a.electionEventId, _c = _a.showActions, showActions = _c === void 0 ? true : _c;
    var record = useRecordContext();
    var t = useTranslation().t;
    var _d = useLogsPermissions(), canExportLogs = _d.canExportLogs, showLogsColumns = _d.showLogsColumns;
    var getHeadField = function (record, field) {
        var message = JSON.parse(record === null || record === void 0 ? void 0 : record.message);
        if (!message ||
            !message.statement ||
            !message.statement.head ||
            !message.statement.head[field]) {
            return _jsx("span", { children: "-" });
        }
        return message.statement.head[field];
    };
    var _e = React.useState(false), openExport = _e[0], setOpenExport = _e[1];
    var _f = React.useState(ExportFormat.CSV), exportFormat = _f[0], setExportFormat = _f[1];
    var handleExportWithOptions = function (format) {
        setExportFormat(format);
        setOpenExport(true);
        setAnchorEl(null);
    };
    var filterObject = {
        election_event_id: electionEventId || (record === null || record === void 0 ? void 0 : record.id) || undefined,
    };
    if (filterToShow) {
        filterObject[filterToShow] = filterValue || undefined;
    }
    var _g = useState(null), anchorEl = _g[0], setAnchorEl = _g[1];
    var filters = [
        _jsx(TextInput, { source: "user_id", label: t("logsScreen.column.user_id") }, "user_id"),
        _jsx(TextInput, { source: "username", label: t("logsScreen.column.username") }, "username"),
        _jsx(DateTimeInput, { source: "created", label: t("logsScreen.column.created") }, "created"),
        _jsx(DateTimeInput, { source: "statement_timestamp", label: t("logsScreen.column.statement_timestamp") }, "statement_timestamp"),
        _jsx(TextInput, { source: "statement_kind", label: t("logsScreen.column.statement_kind") }, "statement_kind"),
    ];
    return (_jsxs(_Fragment, { children: [_jsxs(List, __assign({ resource: "electoral_log", actions: showActions && (_jsx(ListActions, { withColumns: showLogsColumns, withImport: false, openExportMenu: function (e) { return setAnchorEl(e.currentTarget); }, withExport: canExportLogs, withFilter: true })), filters: filters, filter: filterObject, storeKey: false, sort: {
                    field: "id",
                    order: "DESC",
                }, aside: aside }, { children: [_jsx(ResetFilters, {}), _jsxs(DatagridConfigurable, __assign({ omit: OMIT_FIELDS, bulkActionButtons: false }, { children: [_jsx(NumberField, { source: "id", label: t("logsScreen.column.id") }), _jsx(FunctionField, { source: "user_id", label: t("logsScreen.column.user_id"), render: function (record) {
                                    var userId = JSON.parse(record.message).user_id;
                                    return (_jsx("span", __assign({ style: { display: "block", textAlign: "center" } }, { children: !userId || userId === "null" ? _jsx("span", { children: "-" }) : userId })));
                                } }), _jsx(FunctionField, { source: "username", label: t("logsScreen.column.username"), render: function (record) {
                                    var username = JSON.parse(record.message).username;
                                    return (_jsx("span", __assign({ style: { display: "block", textAlign: "center" } }, { children: !username || username === "null" ? _jsx("span", { children: "-" }) : username })));
                                } }), _jsx(FunctionField, { source: "created", label: t("logsScreen.column.created"), render: function (record) { return new Date(record.created * 1000).toUTCString(); } }), _jsx(FunctionField, { source: "statement_timestamp", label: t("logsScreen.column.statement_timestamp"), render: function (record) {
                                    return new Date(record.statement_timestamp * 1000).toUTCString();
                                } }), _jsx(TextField, { source: "statement_kind" }), _jsx(FunctionField, { source: "event_type", label: t("logsScreen.column.statement_kind"), render: function (record) { return getHeadField(record, "event_type"); } }), _jsx(FunctionField, { source: "log_type", label: t("logsScreen.column.log_type"), render: function (record) { return getHeadField(record, "log_type"); } }), _jsx(FunctionField, { source: "description", label: t("logsScreen.column.description"), render: function (record) { return (_jsx(MessageField, { content: getHeadField(record, "description"), initialLength: 50 })); } }), _jsx(MessageField, { source: "message" })] }))] })), _jsx(ExportDialog, { electionEventId: (_b = record.id) !== null && _b !== void 0 ? _b : "", openExport: openExport, setOpenExport: setOpenExport, exportFormat: exportFormat }), _jsxs(Menu, __assign({ id: "menu-export-logs", anchorEl: anchorEl, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, keepMounted: true, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                }, open: Boolean(anchorEl), onClose: function () { return setAnchorEl(null); } }, { children: [_jsx(MenuItem, __assign({ className: "menu-export-csv", onClick: function () { return handleExportWithOptions(ExportFormat.CSV); } }, { children: _jsx("span", __assign({ className: "help-menu-item-CSV" }, { children: t("logsScreen.actions.csv") })) })), _jsx(MenuItem, __assign({ className: "menu-export-pdf", onClick: function () { return handleExportWithOptions(ExportFormat.PDF); } }, { children: _jsx("span", __assign({ className: "help-menu-item-PDF" }, { children: t("logsScreen.actions.pdf") })) }))] }))] }));
};
